import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useCanUserDo, useCanUserDoOnSomeProject } from "../canUserDo";

export function Administration() {
  const location = useLocation();
  const canReadCategory = useCanUserDoOnSomeProject("CATEGORY_READ");
  const canManageApplication = useCanUserDo("ADMIN_SETTING_MANAGE");
  const canManageProcesses = useCanUserDo("PROCESS_MANAGE");
  const canManageUsers = useCanUserDoOnSomeProject("USER_MANAGE");
  const canManageUsersAsAdmin = useCanUserDo("ADMIN_USER_MANAGE");

  if (location.pathname === "/administration") return <Navigate to="users" replace />;

  if (location.pathname === "/administration/users" && (canManageUsers || canManageUsersAsAdmin))
    return <Outlet />;

  if (location.pathname === "/administration/customization" && canManageApplication)
    return <Outlet />;

  if (
    location.pathname.includes("/administration/processes") &&
    (canManageProcesses || canManageApplication)
  )
    return <Outlet />;

  if (location.pathname.includes("/administration/classification") && canReadCategory)
    return <Outlet />;

  return null;
}
